'use client';

import { useGlobalLoadingAtom } from '@/state';
import useIsMovingToOtherPath from '@/utils/useIsMovingToOtherPath';
import Link, { type LinkProps } from 'next/link';

// LinkProps は href/onClick 等のリンク固有プロップしか持たず className などのアンカー属性を含まない。
// Link は実行時にアンカー属性をそのまま <a> へ流すため、型でも AnchorHTMLAttributes を許可する。
// Omit のキーは LinkProps<unknown> で取り、RouteType を巻き込まない（href の RouteType 推論を LinkProps<RouteType> 側だけに保つため）。
interface LoadingLinkProps<RouteType>
  extends LinkProps<RouteType>,
    Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps<unknown>> {
  enableGlobalLoading?: boolean;
  children?: React.ReactNode;
}

// 画面遷移中にローディングアニメーションを差し込むLinkコンポーネント
function LoadingLink<RouteType>({
  enableGlobalLoading = true,
  onClick,
  href,
  children,
  ...props
}: LoadingLinkProps<RouteType>) {
  const [_, startGlobalLoading] = useGlobalLoadingAtom();
  const isMovingToOtherPath = useIsMovingToOtherPath();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // 元のonClickがある場合は実行
    if (onClick) {
      onClick(e);
    }

    // ローディングフラグがtrueで、かつ異なるパスへの移動の場合のみローディング開始
    if (enableGlobalLoading && isMovingToOtherPath(href)) {
      startGlobalLoading();
    }
  };

  return (
    <Link href={href} onClick={handleClick} {...props}>
      {children}
    </Link>
  );
}

export default LoadingLink;
